<template>
  <div class="notification_root_div">
    <v-expansion-panels accordion flat tile class="rounded-br-xl v-step-9" v-model="is_expanded" :value="is_msg_expand">
      <v-expansion-panel class="pa-0">
        <v-expansion-panel-header hide-actions class="pa-2 yellow darken-2"
          >
          <v-icon v-if="is_msg_expand == 0">mdi-close</v-icon>
          <v-badge v-else color="green" :content="unreadTotalCount"  bottom overlap :value="unreadTotalCount">
          <v-icon color="white">mdi-message-text-outline</v-icon>
          </v-badge>
          </v-expansion-panel-header
        >
        <v-expansion-panel-content class="notification_list">
          <v-card>
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="4" class="chat-area-list d-flex align-start flex-column">
                   <v-list
                    dense
                    class="pa-0"
                    v-if="private_messages.length"
                  >
                    <template
                      v-for="(attendee) in private_messages"
                    >
                    <v-list-item :key="attendee.msg_id"  @click="openPrivateChat(attendee)">
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                            <span class="">
                              {{attendee.first_name}} {{attendee.last_name}} <span v-if="attendee.total_unread_msg">({{attendee.total_unread_msg}})</span>
                            </span>
                            <v-spacer></v-spacer>                            
                            <!-- <v-icon @click="removeTemp(attendee)">mdi-delete</v-icon> -->
                          </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    </template>
                   </v-list>
                    <v-list
                    dense
                    class="pa-0 mb-auto"
                    v-if="reversedNotifications.length"
                  >
                    <v-subheader>INFO DESK</v-subheader>
                    <template
                      v-for="(notification) in reversedNotifications"
                    >
                      <v-list-item
                        :key="'info-desk-'+notification.msg_id"
                        @click="openInfoChat(notification)"
                        :class="{
                          'grey lighten-4':
                            selected_chat == notification.msg_id
                        }"
                      >
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                              <span>
                                {{ notification.attendee_data.first_name }} {{ notification.attendee_data.last_name }}
                              </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider :key="'info-desk-divider'+notification.msg_id"></v-divider>
                    </template>
                  </v-list>
                </v-col>
                <v-col cols="8" v-if="!is_private_chat && selected_chat" class="min-h-400">
                  <ChatReply v-if="is_reply" />
                  <InfoDeskChatInline v-if="!is_reply" />
                </v-col>
                <v-col cols="8" v-if="is_private_chat" class="min-h-400">
                  <ChatBox  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="quick_notifications">
      <v-alert
      dismissible
      color="primary"
      border="left"
      elevation="2"
      colored-border
      icon="mdi-message"      
      v-for="(notification,index) in quick_notifications" :key="index"
      :max-width="notification.max_width"      
    >    
    <div v-if="notification.data.type == 'private_message'">
      You have new message from {{notification.data.attendee_data.first_name}} {{notification.data.attendee_data.last_name}}
      <v-btn small text color="success" dark @click="openPrivateChat(notification.data.attendee_data,true)">Reply <v-icon>mdi-reply</v-icon></v-btn>
    </div>
    <div v-else-if="notification.data.type == 'infodesk'">
      You have new message from {{notification.data.attendee_data.first_name}} {{notification.data.attendee_data.last_name}} in Infodesk
    </div>
    <div v-else-if="notification.data.type == 'booth_visit'">
      {{notification.data.first_name}} {{notification.data.last_name}} Visted your booth
    </div>
    <div v-else>
      <span class="text-justify">{{notification.data.message}}</span>      
    </div>
    </v-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations,mapGetters } from "vuex";
import ChatReply from "../infodesk/ChatReply";
import InfoDeskChatInline from "../infodesk/ChatInline";
import ChatBox from '../afterAuth/ChatBox'
export default {
  name: "Notifications",
  components: {
    ChatReply,
    InfoDeskChatInline,
    ChatBox
  },
  data() {
    return {
      chat_url: document.location.origin + "/info-desk-chat/reply/",
      infodesk_url: document.location.origin + "/info-desk-chat",
      selected_chat: null,
      is_reply: false
    };
  },
  computed: {
    ...mapState("notifications", ["is_msg_expand","unread_counter", "infodesk_messages","is_private_chat","private_messages","quick_notifications"]),
    ...mapGetters("notifications",["unreadTotalCount"]),
    is_expanded : {
      get: function () {
        return this.is_msg_expand
      },
      set: function (newValue) {
        this.setExpandBox(newValue)
      }
    },
    reversedNotifications() {
      let reverseArray = [];
      if (this.infodesk_messages.length) {
        for (
          var i = 0, j = this.infodesk_messages.length - 1;
          i < this.infodesk_messages.length;
          i++, j--
        ) {
          reverseArray.push(this.infodesk_messages[j]);
        }
        return reverseArray;
      }
      return reverseArray;
    },
    myself() {
      return JSON.parse(localStorage.getItem("flaacos_user"));
    }
  },
  methods: {
    ...mapActions("notifications", ["getInfoDeskMessage","getPrivateMessages"]),
    ...mapMutations("notifications", ["setChatUser","setChatPrivate","setPrivateChatUser","setExpandBox","removeTemp"]),
    openInfoChat(notification) {
      this.setChatPrivate(false)
      if (this.myself.heldesk_data) {
        this.selected_chat = notification.msg_id;
        this.is_reply = true;
        if (!notification.received_by) {
          this.setChatUser(notification.attendee_data);
        } else {
          this.setChatUser(notification.original_sender.attendee_data);
        }
      } else {
        this.selected_chat = notification.msg_id;
        this.is_reply = false;
      }
    },
    openPrivateChat(attendee,openSidebar = false) {      
      this.setChatPrivate(true)
      this.setPrivateChatUser(attendee)
      if(openSidebar){
        this.setExpandBox(0)
      }
    }
  },
  mounted: function () {
    this.getInfoDeskMessage();
    this.getPrivateMessages();
  },
};
</script>
<style>
.v-expansion-panel-header {
  border-radius: 0px 0px 23px 0px;
}
.notification_root_div {
  position: fixed;
  top: 0;
  max-width: 450px;  
  z-index: 5;
  left: 0px;
}
.notification_list {
  min-width: 400px;
}
.min-h-400{
  min-height: 400px;
}
.v-expansion-panel-content__wrap {
  padding: 0px !important;
}
.quick_notifications{
 position: fixed;
 top: 10px;
 right: 10px;
}
.chat-area-list {
  overflow-y: auto;
  min-height: 65vh;
  max-height: 65vh;
}
.top-right {
  position: fixed !important;
  top: 10px;
  right: 10px;
}
</style>